export const AUTH_STATE_KEY = 'auth-state'

interface AuthState {
  redirect?: string | null
  clientToken?: string | null
  email: string
}

export const setAuthState = (state: AuthState) => {
  try {
    localStorage.setItem(AUTH_STATE_KEY, JSON.stringify(state))
  } catch (error) {
    console.error(error)
  }
}

export const getAuthState = (): AuthState | null => {
  if (typeof localStorage != 'object') return null

  try {
    const state = localStorage.getItem(AUTH_STATE_KEY)
    return state ? JSON.parse(state) : {}
  } catch (error) {
    console.error(error)
    return null
  }
}
